/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.moderation.getAccountTimeline'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  timeline: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<TimelineItem>((() => timelineItem) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get timeline of all available events of an account. This includes moderation events, account history and did history. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['RepoNotFound'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type TimelineItem = {
  $type?: 'tools.ozone.moderation.getAccountTimeline#timelineItem'
  day: string
  summary: TimelineItemSummary[]
}

export type { TimelineItem }

const timelineItem = /*#__PURE__*/ l.typedObject<TimelineItem>(
  $nsid,
  'timelineItem',
  /*#__PURE__*/ l.object({
    day: /*#__PURE__*/ l.string(),
    summary: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<TimelineItemSummary>(
        (() => timelineItemSummary) as any,
      ),
    ),
  }),
)

export { timelineItem }

type TimelineItemSummary = {
  $type?: 'tools.ozone.moderation.getAccountTimeline#timelineItemSummary'
  eventSubjectType: 'account' | 'record' | 'chat' | l.UnknownString
  eventType:
    | 'tools.ozone.moderation.defs#modEventTakedown'
    | 'tools.ozone.moderation.defs#modEventReverseTakedown'
    | 'tools.ozone.moderation.defs#modEventComment'
    | 'tools.ozone.moderation.defs#modEventReport'
    | 'tools.ozone.moderation.defs#modEventLabel'
    | 'tools.ozone.moderation.defs#modEventAcknowledge'
    | 'tools.ozone.moderation.defs#modEventEscalate'
    | 'tools.ozone.moderation.defs#modEventMute'
    | 'tools.ozone.moderation.defs#modEventUnmute'
    | 'tools.ozone.moderation.defs#modEventMuteReporter'
    | 'tools.ozone.moderation.defs#modEventUnmuteReporter'
    | 'tools.ozone.moderation.defs#modEventEmail'
    | 'tools.ozone.moderation.defs#modEventResolveAppeal'
    | 'tools.ozone.moderation.defs#modEventDivert'
    | 'tools.ozone.moderation.defs#modEventTag'
    | 'tools.ozone.moderation.defs#accountEvent'
    | 'tools.ozone.moderation.defs#identityEvent'
    | 'tools.ozone.moderation.defs#recordEvent'
    | 'tools.ozone.moderation.defs#modEventPriorityScore'
    | 'tools.ozone.moderation.defs#revokeAccountCredentialsEvent'
    | 'tools.ozone.moderation.defs#ageAssuranceEvent'
    | 'tools.ozone.moderation.defs#ageAssuranceOverrideEvent'
    | 'tools.ozone.moderation.defs#timelineEventPlcCreate'
    | 'tools.ozone.moderation.defs#timelineEventPlcOperation'
    | 'tools.ozone.moderation.defs#timelineEventPlcTombstone'
    | 'tools.ozone.hosting.getAccountHistory#accountCreated'
    | 'tools.ozone.hosting.getAccountHistory#emailConfirmed'
    | 'tools.ozone.hosting.getAccountHistory#passwordUpdated'
    | 'tools.ozone.hosting.getAccountHistory#handleUpdated'
    | 'tools.ozone.moderation.defs#scheduleTakedownEvent'
    | 'tools.ozone.moderation.defs#cancelScheduledTakedownEvent'
    | l.UnknownString
  count: number
}

export type { TimelineItemSummary }

const timelineItemSummary = /*#__PURE__*/ l.typedObject<TimelineItemSummary>(
  $nsid,
  'timelineItemSummary',
  /*#__PURE__*/ l.object({
    eventSubjectType: /*#__PURE__*/ l.string<{
      knownValues: ['account', 'record', 'chat']
    }>(),
    eventType: /*#__PURE__*/ l.string<{
      knownValues: [
        'tools.ozone.moderation.defs#modEventTakedown',
        'tools.ozone.moderation.defs#modEventReverseTakedown',
        'tools.ozone.moderation.defs#modEventComment',
        'tools.ozone.moderation.defs#modEventReport',
        'tools.ozone.moderation.defs#modEventLabel',
        'tools.ozone.moderation.defs#modEventAcknowledge',
        'tools.ozone.moderation.defs#modEventEscalate',
        'tools.ozone.moderation.defs#modEventMute',
        'tools.ozone.moderation.defs#modEventUnmute',
        'tools.ozone.moderation.defs#modEventMuteReporter',
        'tools.ozone.moderation.defs#modEventUnmuteReporter',
        'tools.ozone.moderation.defs#modEventEmail',
        'tools.ozone.moderation.defs#modEventResolveAppeal',
        'tools.ozone.moderation.defs#modEventDivert',
        'tools.ozone.moderation.defs#modEventTag',
        'tools.ozone.moderation.defs#accountEvent',
        'tools.ozone.moderation.defs#identityEvent',
        'tools.ozone.moderation.defs#recordEvent',
        'tools.ozone.moderation.defs#modEventPriorityScore',
        'tools.ozone.moderation.defs#revokeAccountCredentialsEvent',
        'tools.ozone.moderation.defs#ageAssuranceEvent',
        'tools.ozone.moderation.defs#ageAssuranceOverrideEvent',
        'tools.ozone.moderation.defs#timelineEventPlcCreate',
        'tools.ozone.moderation.defs#timelineEventPlcOperation',
        'tools.ozone.moderation.defs#timelineEventPlcTombstone',
        'tools.ozone.hosting.getAccountHistory#accountCreated',
        'tools.ozone.hosting.getAccountHistory#emailConfirmed',
        'tools.ozone.hosting.getAccountHistory#passwordUpdated',
        'tools.ozone.hosting.getAccountHistory#handleUpdated',
        'tools.ozone.moderation.defs#scheduleTakedownEvent',
        'tools.ozone.moderation.defs#cancelScheduledTakedownEvent',
      ]
    }>(),
    count: /*#__PURE__*/ l.integer(),
  }),
)

export { timelineItemSummary }
